import type { CSSProperties } from 'react';
import { Layers } from 'lucide-react';
import type { CwInboxFull } from '@/api/inboxTypes';
import { channelKind } from '@/lib/channels';

interface Props {
  inboxes: CwInboxFull[];
  selected: number | 'all';
  onSelect: (c: number | 'all') => void;
  /** Непрочитанные: по каналам и всего (undefined — счётчики недоступны). */
  unread?: { all: number; byInbox: Record<string, number> } | null;
}

const cnt = (n: number) => (n > 99 ? '99+' : String(n));

/** Лента каналов: «Все» и по плитке на канал кабинета, у каждой — число непрочитанных. */
export function ChannelRail({ inboxes, selected, onSelect, unread }: Props) {
  return (
    <div className="rail" role="group" aria-label="Каналы">
      <button
        type="button"
        className="chn"
        style={{ '--c': 'var(--accent)' } as CSSProperties}
        aria-pressed={selected === 'all'}
        aria-label={`Все каналы${unread?.all ? `, непрочитанных ${unread.all}` : ''}`}
        onClick={() => onSelect('all')}
      >
        <span className="tile">
          <Layers aria-hidden />
          {!!unread?.all && <span className="cnt tnum">{cnt(unread.all)}</span>}
        </span>
        Все
      </button>
      {inboxes.map((i) => {
        const kind = channelKind(i.channel_type);
        const Icon = kind.icon;
        const n = unread?.byInbox[String(i.id)] ?? 0;
        return (
          <button
            key={i.id}
            type="button"
            className="chn"
            style={{ '--c': kind.color } as CSSProperties}
            aria-pressed={selected === i.id}
            aria-label={`${i.name}${n ? `, непрочитанных ${n}` : ''}`}
            onClick={() => onSelect(i.id)}
          >
            <span className="tile">
              <Icon aria-hidden />
              {n > 0 && <span className="cnt tnum">{cnt(n)}</span>}
            </span>
            <span className="max-w-16 truncate">{i.name}</span>
          </button>
        );
      })}
    </div>
  );
}
